module.exports = __webpack_public_path__ + "img/exit-outline.caf87f40.svg";